import { createGlobalStyle } from 'styled-components';
import '../font/fonts.css';
import dropImg from '../icon/drop down icon.png';
import dropSelectedImg from '../icon/drop down icon_selected.png';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    /* font-family: "AppleSDNeo"; */
    font-family: "Inter";
    font-size:${theme.fontSizes.medium};
    font-weight: 350;

    /* font-style: normal; */
    /* vertical-align: baseline/; *
    /* font: inherit; */
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  *::selection{
    /* border: 1px solid ${theme.colors.blueMain}; */
  }
  ::-moz-selection {
  color: #fff;
  background: ${theme.colors.blueMain};
}
  .ant-select:hover{
    /* border: 1px solid ${theme.colors.blueMain}; */
  }
  select{
    /* 디폴트 스타일 제거 */
    -moz-appearance: none; /* chrome */
    -webkit-appearance: none; /* firefox */
    appearance: none;
    background: url(${dropImg}) no-repeat 93% 50%/13px auto;
    /* background-position: 90%; */
    background-color: #fff ;
    padding: 8px 10px;
    width: 185px;
    border-radius: 3px;
    transition: 0.2s;
    height: 2.5rem;
    line-height: 2.5rem;
    -moz-appearance:none;
  }
  select:hover{
    background: url(${dropSelectedImg}) no-repeat 93% 50%/13px auto;
    background-color: #fff ;
  }
  select:active{
    background: url(${dropSelectedImg}) no-repeat 93% 50%/13px auto;
    background-color: #fff ;
  }
  select::-ms-expand{
   display:none;/*for IE10,11*/
  }

  button {
    cursor: pointer;
    background: inherit;
    border: none;
    padding: 0;
    margin: 0;
    transition: all 0.2s ease 0s;
    box-sizing: border-box;

    &:hover{
      box-sizing: border-box;

    }
  }
  a{
    color: ${theme.colors.black};
  }
  label{
        color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }
  input, textarea{
    border: none;
    padding: 8px 10px;
    border-radius: 3px;
    width: 100%;
    &:placeholder{
      color: ${theme.colors.inputGray}
    }
  }
  input:focus, textarea:focus, select:focus{
        outline: none;
    }
     /* 스크롤바 전체 */
  &::-webkit-scrollbar {
    width: 0.5rem;
    overflow: visible;
  }
  /* 스크롤 막대 */
  &::-webkit-scrollbar-thumb {
    overflow: visible;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.06);
  }
  /* 스크롤 막대 외부 */
  &::-webkit-scrollbar-track {
    width: 0.6rem;
    /* background-color: red; */
  }
  .ant-select-selector
  .ant-table-thead > tr > th{
    font-weight: 900;
  }
   .ant-select-dropdown >div >div > div >div > div >div >div >div {
    margin-right: 3rem;
    height: 100%;
    width: 80% !important;
    margin: 0;
   }
    .ant-select-dropdown >div >div > div >div > div >div{
      height: 100%;
      width: 100%;
    }
   /* 숫자 추가빼기 버튼 */
  input[type=number]::-webkit-inner-spin-button {
    /* margin-right: -10px;
    margin-left: 8px; */
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
}

/* 사이드바 접었을 때 보여지는 서브 팝업 메뉴 */
.ant-menu-submenu,
.ant-menu-submenu-popup {
  >.ant-menu .ant-menu-item .ant-menu-item-icon,
  >.ant-menu .ant-menu-submenu-title .ant-menu-item-icon {
    vertical-align:-0.35em;
  }
  li {
    img {
      width: 1.5rem;
    }
  }
}



.item {
  /* //sort item  */
    z-index: 999999 !important;
  }

  .filepond--root .filepond--drop-label {
    height: 100%;
    /* border: solid 2px red; */
  }

  .ant-tag {
    background: ${theme.colors.gray_4} !important;
  }

.ant-layout{
  background: #ffffff;
}

.table-header-title{
  font-size: ${theme.fontSizes.normal};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.dark_300};
  text-transform: uppercase;
}

.table-row-text{
  color: ${theme.colors.dark_400};
  font-size: ${theme.fontSizes.sm};
  font-style: normal;
  font-weight: ${theme.fontWeights.medium};
  line-height: 20px;
  letter-spacing: 0.2px;
}

.vertical-align{
  display: flex;
  align-items: center;
}

.turText {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }

  .title{
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .tips{
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color:#c53434;
  }

  .length-subtext {
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    /* margin-top: 8px !important; */
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.dark_200};
  }

    /* Remove spinner arrows in Firefox */
    input[type='number'] {
    -moz-appearance: textfield;
  }

  /* Remove spinner arrows in WebKit-based browsers */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input:disabled {
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    color: ${theme.colors.dark_300}
  }
  input:disabled:hover {
    border: 1px solid ${theme.colors.gray_5};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}
.disabled-text{
  font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200}
}

.flex-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit-heavy-title{
font-size: ${theme.fontSizes.lg};
font-weight: ${theme.fontWeights.bold};
line-height: 32px;
letter-spacing: 0.1px;
color: ${theme.colors.dark_500}
}
`;

export default GlobalStyle;
